import PropTypes from 'prop-types'
import React, { useCallback, useMemo } from 'react'
import { useField } from 'formik'
import DatePicker, { registerLocale } from 'react-datepicker'
import es from 'date-fns/locale/es'
import 'react-datepicker/dist/react-datepicker.css'
import { Box } from '@chakra-ui/react'
import { format, parse } from 'date-fns'

registerLocale('es', es)

export function DatePickerField({ isClearable = true, ...props }) {
  const [field, , { setValue }] = useField(props)
  const handleChange = useCallback(
    (newValue) => {
      if (newValue) {
        const formatDate = format(newValue, 'dd-MM-yyyy')
        setValue(formatDate)
      } else {
        setValue(null)
      }
    },
    [setValue],
  )
  const formatValue = useMemo(() => {
    return field.value ? parse(field.value, 'dd-MM-yyyy', new Date()) : null
  }, [field])

  return (
    <Box
      position="relative"
      display="inline-block"
      width="100%"
      fontSize="13px"
      borderRadius="4px"
      boxShadow="inset 0 2px 2px #e9e9e9"
      border="1px solid #aeaeae"
      lineHeight="16px"
      padding="6px 10px 5px"
    >
      <DatePicker
        {...props}
        selected={formatValue}
        onChange={handleChange}
        showYearDropdown
        isClearable={isClearable}
        dateFormat="dd/MM/yyyy"
        dateFormatCalendar="MMMM"
        locale={es}
        yearDropdownItemNumber={30}
        scrollableYearDropdown
      />
    </Box>
  )
}

DatePickerField.propTypes = {
  isClearable: PropTypes.bool,
}
